import React from 'react';
import {LinkOnComponent} from 'app/components/links/link';
import {FONTS, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {TextContent} from 'app/components/news/NewsStylings';

const ImageWrapper = styled.div`
  min-width: ${SIZES['96']};
  width: ${SIZES['96']};
  height: ${SIZES['96']};
  border-radius: 0.25rem;
  overflow: hidden;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
`;

const TextContainer = styled.div`
  padding-left: 0.5rem;
  display: flex;
  flex-direction: column;

  h3 {
    font-size: ${FONTS['14']};
    margin-top: 0;
    margin-bottom: 0.25rem;
  }
`;

const SimilarNews = ({similarNews}) => {
  if (!similarNews.length) {
    return null;
  }

  const similarNewsList = similarNews.map(news => {
    return (
      <LinkOnComponent key={news.id} to={`/news/${news.slug}`}>
        <Container>
          <ImageWrapper>
            <Image entity={'news'} ratio={'1:1'} height={96} width={96} src={news.image} />
          </ImageWrapper>
          <TextContainer>
            <Typography variant={'subheading2'}>{news.title}</Typography>
            <Typography variant={'caption1'}>{news.subtitle}</Typography>
          </TextContainer>
        </Container>
      </LinkOnComponent>
    );
  });

  return (
    <TextContent>
      <Typography variant={'subheading2'}>Das könnte dich auch interessieren</Typography>
      <div>{similarNewsList}</div>
    </TextContent>
  );
};

export default SimilarNews;
